module.exports = __webpack_public_path__ + "static/assets/d6b5a7c73d79d8074f3ffb529920ab7a.svg";